module.exports = __webpack_public_path__ + "nurse-head-backgraund.png?f9d5d1f1d5f816688fbc6858cb0911c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nurse-head-backgraund.png
// module id = 307
// module chunks = 0